import React from 'react';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../BlockTabs';
import { Loader } from '../components';
import ChartContainer from '../metrics/DataByDayChart';
import TableContainer from '../metrics/TableContainer';
import { useGetDashboardDataByDayQuery } from '../../api/dashboardApiSlice';

export default function DeviceDataByDay ( {filter} ) {
	const { t } = useTranslation();
  const {data = [], isSuccess, isLoading, isError, refetch} = useGetDashboardDataByDayQuery({filter})
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && isError), retry: refetch }
  return (
    <BlockTabs title={t("dataByDay.title")} defaultActiveKey="chart">
      <Loader {...loaderProps} key="table" title="table">
        <TableContainer data={data} />
      </Loader>
      <Loader {...loaderProps} key="chart" title="chart" >
        <ChartContainer data={data} />
      </Loader>
    </BlockTabs>
  )
}
